import type { GetRecentFollowingContentsResBody } from '@tmap-web-lib/remote-api-client/frontman'

import { getRecentFollowingContents } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface UseGetRecentFollowingContentsProps {
  lon: number
  lat: number
  size?: number
  enabled?: boolean
}

function useGetRecentFollowingContents({ lon, lat, size = 20, enabled = true }: UseGetRecentFollowingContentsProps) {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<GetRecentFollowingContentsResBody, AxiosError>(
    KEYS.RECENT_FOLLOWING_CONTENTS(lon, lat),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<GetRecentFollowingContentsResBody>(
          'activity/api/v3/profile/me/following-contents/latest',
        )
        return data
      }
      const { data } = await getRecentFollowingContents({ lon, lat, size })
      return data
    },
    { enabled, useErrorBoundary: false },
  )
}

export { useGetRecentFollowingContents }
export type { UseGetRecentFollowingContentsProps }
